module.exports = __webpack_public_path__ + "media/favicon/favicon-41da11cd4486776dc5c90e01f7045309.ico";